document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('[data-fam-cart-form]');
  if (form) {
    form.querySelectorAll('[data-fam-qty-stepper]').forEach(function (stepper) {
      stepper.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        var input = stepper.querySelector('input');
        var val = parseInt(input.value, 10) || 1;
        val = btn.getAttribute('data-fam-qty-action') === 'increase' ? val + 1 : Math.max(0, val - 1);
        input.value = val;
        form.submit();
      });
    });
  }

  var discountForm = document.querySelector('[data-fam-discount-form]');
  if (discountForm) {
    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = discountForm.querySelector('input[name="discount"]').value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }
});
